import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Api from '../../libs/Api';
import { useIsMounted } from '../../utils/useIsMounted';

const EditToolTeste = () => {
  const isMounted = useIsMounted();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (!isMounted()) {
        return;
      }

      const responses = await Api.getMeUser();

      if (responses?.type !== 'ADM') {
        history.push('/');
      }
    })();
  }, [history, isMounted]);

  return (
    <div>
      <h1>Rota teste de Editar Exames</h1>
      <p>Uma rota livre para conteúdo estático</p>
    </div>
  );
};

export default EditToolTeste;
